import { render, staticRenderFns } from "./MeetingClosureActions.vue?vue&type=template&id=52a120e6&"
import script from "./MeetingClosureActions.vue?vue&type=script&lang=js&"
export * from "./MeetingClosureActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports